/**
 * @flow
 * @relayHash 047437b449b3ff1945e230414f605af6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SendReadyForSignatureReminderToFollowersInput = {|
  jobId: string,
  clientMutationId?: ?string,
|};
export type SendReadyForSignatureReminderMutationVariables = {|
  input: SendReadyForSignatureReminderToFollowersInput
|};
export type SendReadyForSignatureReminderMutationResponse = {|
  +sendReadyForSignatureReminderToFollowers: ?{|
    +notificationCount: ?number
  |}
|};
export type SendReadyForSignatureReminderMutation = {|
  variables: SendReadyForSignatureReminderMutationVariables,
  response: SendReadyForSignatureReminderMutationResponse,
|};
*/


/*
mutation SendReadyForSignatureReminderMutation(
  $input: SendReadyForSignatureReminderToFollowersInput!
) {
  sendReadyForSignatureReminderToFollowers(input: $input) {
    notificationCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SendReadyForSignatureReminderToFollowersInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendReadyForSignatureReminderToFollowers",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendReadyForSignatureReminderToFollowersPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notificationCount",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SendReadyForSignatureReminderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SendReadyForSignatureReminderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SendReadyForSignatureReminderMutation",
    "id": null,
    "text": "mutation SendReadyForSignatureReminderMutation(\n  $input: SendReadyForSignatureReminderToFollowersInput!\n) {\n  sendReadyForSignatureReminderToFollowers(input: $input) {\n    notificationCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '44c2932e39de130eadafd5f704f72cd4';
module.exports = node;
